import { type LiveAgentConfig, liveAgentConfig } from './liveAgent.js';

/**
 * 403 (#1317): which customer support chat runs, chosen at runtime from `config.js` (Constitution II), so staff can
 * switch between Freshchat, LiveAgent (378's trial) and none without a release. A choice whose values are missing or
 * malformed means none: nothing loads and no request reaches any chat provider.
 */
export type ChatProvider =
  | { kind: 'freshchat'; scriptUrl: string }
  | { kind: 'liveagent'; config: LiveAgentConfig }
  | null;

// Freshchat's account loader, exactly as its install code gives it (https, no query, no other host).
const FRESHCHAT_LOADER = /^https:\/\/fw-cdn\.com\/\d+\/\d+\.js$/;

export function chatProviderFrom(raw: {
  chatProvider?: string;
  freshchatScriptUrl?: string;
  liveAgentUrl?: string;
  liveAgentButtonId?: string;
}): ChatProvider {
  let choice = (raw.chatProvider ?? '').trim().toLowerCase();
  // A placeholder envsubst left behind ("${CHAT_PROVIDER}") is no choice at all.
  if (choice.startsWith('${')) choice = '';
  const liveAgent = liveAgentConfig(raw);
  if (choice === 'freshchat') {
    const scriptUrl = (raw.freshchatScriptUrl ?? '').trim();
    return FRESHCHAT_LOADER.test(scriptUrl) ? { kind: 'freshchat', scriptUrl } : null;
  }
  // No choice keeps 378's behaviour: LiveAgent whenever its values are set.
  if (choice === 'liveagent' || choice === '')
    return liveAgent ? { kind: 'liveagent', config: liveAgent } : null;
  return null;
}
